import React from "react";
import { CCard, CCardBody } from "@coreui/react";

import { WithdrawAddressesSection } from "./WithdrawAddressesSection";

export const UserSettingsPage: React.FC = () => {
  return (
    <CCard className="UserSettingsPage">
      <CCardBody>
        <WithdrawAddressesSection />
      </CCardBody>
    </CCard>
  );
};
